<template>
  <div shadow="hover">
    <iframe
      v-if="iframeSrc"
      :src="iframeSrc"
      frameborder="0"
      allowfullscreen
      height="560"
      width="100%"
    >
    </iframe>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { base64ToBytes } from '@/libs/utils/functions/base64'

export default {

  props: {
    bytes: {
      required: true,
      type: [ArrayBuffer, String]
    }
  },

  data () {
    return {
      iframeSrc: null
    }
  },

  methods: {
    ...mapActions({
      resetLoader: 'loader/resetLoader',
      setLoaderWithText: 'loader/setLoaderWithText'
    }),
    renderPDF () {
      const byteArray = this.bytes instanceof ArrayBuffer ? new Uint8Array(this.bytes) : base64ToBytes(this.bytes)

      const blob = new Blob([byteArray], { type: 'application/pdf' })
      this.iframeSrc = URL.createObjectURL(blob)
    }
  },

  mounted () {
    this.setLoaderWithText({
      status: true,
      text: 'Carregando dados...'
    })
    this.renderPDF()
    this.resetLoader()
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components(new)/UI/Modals/VisualizarDocumentos/PdfViewer/PdfViewer.vue